//src/theme.js
import { createTheme } from "@mui/material/styles";

export const colorPrimitives = {
  base: {
    redAlert: "#E11B00",
    redAlertHovered: "#F73F26",
    redAlertDark: "#FF7765",
    redLight: "#FFF7F5",
    redDark: "#372424",
    red1: "#FF8B66",
    red2: "#FFAB99",
    red3: "#D7633E",

    yellow1: "#FFDE67",
    yellow2: "#E1C049",

    blue1: "#66DAFF",
    blue2: "#A0E8FF",
    blue3: "#E5F9FF",
    blue4: "#2A9EC3",
    blue5: "#D1E5EB",

    green1: "#66F59F",
    green2: "#34C36D",

    gray1: "#A6A6A6",
    gray2: "#D1D1D1",
    gray3: "#F3F3F3",
    gray4: "#F1F1F1",

    black: "#1B1B1B",
    white: "#FFFFFF",
    darkGray: "#121212",
    lightGray: "#F5F5F5",
  },
  accentBlue: {
    light: {
      100: "#005DD7",
      80: "#0085FF",
      60: "#66B6FF",
      40: "#99CEFF",
      20: "#CCE7FF",
      10: "#E5F3FF",
      4: "#F5FAFF",
    },
    dark: {
      120: "#36456B",
      100: "#415B9C",
      80: "#3D6FC1",
      60: "#87ADF9",
      10: "#BFCCF9",
    },
  },
  transparent: {
    white: {
      100: "rgba(255, 255, 255, 0.1)",
      70: "rgba(255, 255, 255, 0.3)",
      50: "rgba(255, 255, 255, 0.5)",
      40: "rgba(255, 255, 255, 0.6)",
      10: "rgba(255, 255, 255, 0.9)",
      6: "rgba(255, 255, 255, 0.94)",
    },
    black: {
      blue: "#001A32",
      blue70: "#4D5F70",
      lightBlack: "#282828",
      lightBlackPopover: "#3C3C3C",
      100: "rgba(0, 0, 0, 0.1)",
      70: "rgba(0, 0, 0, 0.3)",
      50: "rgba(0, 0, 0, 0.5)",
      40: "rgba(0, 0, 0, 0.6)",
      10: "rgba(0, 0, 0, 0.9)",
      6: "rgba(0, 0, 0, 0.94)",
      4: "rgba(0, 0, 0, 0.96)",
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    // primary: {
    //   main: colorPrimitives.blue2,
    //   contrastText: colorPrimitives.white,
    // },
    // secondary: {
    //   main: colorPrimitives.redAlert,
    //   contrastText: colorPrimitives.white,
    // },
    TextAndIcon: {
      primaryBlackEnabled: colorPrimitives.transparent.black["100"],
      primaryBlackHovered: colorPrimitives.accentBlue.light["80"],
      secondaryBlackEnabled: colorPrimitives.transparent.black["70"],
      secondaryBlackHovered: colorPrimitives.accentBlue.light["80"],
      primaryBlackBlueEnabled: colorPrimitives.transparent.black.blue,
      primaryBlackBlueHovered: colorPrimitives.accentBlue.light["80"],
      secondaryBlackBlueEnabled: colorPrimitives.transparent.black.blue70,
      secondaryBlackBlueHovered: colorPrimitives.accentBlue.light["80"],
      alertRedEnabled: colorPrimitives.base.redAlert,
      alertRedHovered: colorPrimitives.base.redAlertHovered,
    },
    background: {
      regular: colorPrimitives.base.white,
      popUpBackground: colorPrimitives.transparent.black["70"],
      popOver: colorPrimitives.base.white,
      text: colorPrimitives.transparent.black["4"],
      elements: colorPrimitives.accentBlue.light["10"],
      error: colorPrimitives.base.redLight,
    },
    border: {
      6: colorPrimitives.transparent.black["6"],
      10: colorPrimitives.transparent.black["10"],
      30: colorPrimitives.transparent.black["30"],
    },
    status: {
      red: colorPrimitives.base.red1,
      yellow: colorPrimitives.base.yellow1,
      green: colorPrimitives.base.green1,
      blue1: colorPrimitives.base.blue1,
      blue2: colorPrimitives.base.blue2,
      blue3: colorPrimitives.base.blue3,
      gray: colorPrimitives.base.gray1,
      lighGray: colorPrimitives.base.gray2,
      progressText: colorPrimitives.base.black,
    },
    priority: {
      high: colorPrimitives.base.red2,
      medium: colorPrimitives.base.yellow1,
      low: colorPrimitives.base.gray3,
      content: colorPrimitives.base.black,
    },
  },
  components: {
    inputs: {
      borderEnabled: colorPrimitives.transparent.black["20"],
      iconEnabled: colorPrimitives.transparent.black["30"],
      blackHovered: colorPrimitives.accentBlue.light["80"],
      borderFocused: colorPrimitives.accentBlue.light["80"],
      borderError: colorPrimitives.base.redAlert,
      iconFocused: colorPrimitives.transparent.black["70"],
      backgroundDisabled: colorPrimitives.transparent.black["10"],
      borderErrorEnabled: colorPrimitives.base.redAlert,
      borderErrorHovered: colorPrimitives.base.redAlertHovered,
      helperTextError: colorPrimitives.base.redAlert,
      placeHolder: colorPrimitives.transparent.black["30"],
      label: colorPrimitives.base.black,
      contentText: colorPrimitives.base.black,
      helperText: colorPrimitives.base.black,
    },
    checkbox: {
      empty: {
        enabled: colorPrimitives.transparent.black["70"],
        hovered: colorPrimitives.accentBlue.light["80"],
        disabled: colorPrimitives.transparent.black["30"],
      },
      active: {
        enabled: colorPrimitives.accentBlue.light["80"],
        hovered: colorPrimitives.accentBlue.light["100"],
        disabled: colorPrimitives.accentBlue.light["40"],
        content: colorPrimitives.base.white,
      },
    },
    button: {
      icon: {
        backgroundRegular: colorPrimitives.base.white,
        border: colorPrimitives.transparent.black["10"],
        iconEnabledBlack: colorPrimitives.base.black,
        iconHoveredAccentBlue: colorPrimitives.accentBlue.light["80"],
        iconEnabledDarkBlue: colorPrimitives.transparent.black.blue,
        iconActiveBackground: colorPrimitives.accentBlue.light["10"],
      },
      primary: {
        content: colorPrimitives.base.white,
        backgroundEnabled: colorPrimitives.accentBlue.light["80"],
        backgroundHovered: colorPrimitives.accentBlue.light["40"],
        backgroundFocused: colorPrimitives.accentBlue.light["40"],
        borderAndContentFocused: colorPrimitives.transparent.black.blue,
        backgroundPressed: colorPrimitives.accentBlue.light["60"],
        backgroundDisabled: colorPrimitives.transparent.black["30"],
        backgroundAlert: colorPrimitives.base.redAlert,
        backgroundAlertHovered: colorPrimitives.base.redAlertHovered,
      },
      secondaryAndText: {
        contentAndBorderEnabled: colorPrimitives.accentBlue.light["80"],
        contentAndBorderHovered: colorPrimitives.accentBlue.light["100"],
        contentAndBorderFocused: colorPrimitives.accentBlue.light["100"],
        backgroundFocused: colorPrimitives.accentBlue.light["10"],
        contentAndBorderPressed: colorPrimitives.accentBlue.light["60"],
        contentAndBorderDisabled: colorPrimitives.transparent.black["30"],
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    // primary: {
    //   main: colorPrimitives.blue3,
    //   contrastText: colorPrimitives.black,
    // },
    // secondary: {
    //   main: colorPrimitives.redAlert,
    //   contrastText: colorPrimitives.black,
    // },
    TextAndIcon: {
      primaryBlackEnabled: colorPrimitives.base.white,
      primaryBlackHovered: colorPrimitives.accentBlue.dark["100"],
      secondaryBlackEnabled: colorPrimitives.transparent.white["70"],
      secondaryBlackHovered: colorPrimitives.accentBlue.light["40"],
      primaryBlackBlueEnabled: colorPrimitives.base.white,
      primaryBlackBlueHovered: colorPrimitives.accentBlue.light["4"],
      alertRedEnabled: colorPrimitives.base.redAlert,
      alertRedHovered: colorPrimitives.base.red2,
    },
    background: {
      regular: colorPrimitives.transparent.black.lightBlack,
      popUpBackground: colorPrimitives.transparent.black["70"],
      popOver: colorPrimitives.transparent.black.lightBlackPopover,
      text: colorPrimitives.transparent.white["6"],
      elements: colorPrimitives.accentBlue.dark["120"],
      error: colorPrimitives.base.redDark,
    },
    border: {
      6: colorPrimitives.transparent.white["6"],
      10: colorPrimitives.transparent.white["10"],
      30: colorPrimitives.transparent.white["30"],
    },
    status: {
      red: colorPrimitives.base.red3,
      yellow: colorPrimitives.base.yellow2,
      green: colorPrimitives.base.green2,
      blue1: colorPrimitives.base.blue4,
      blue2: colorPrimitives.base.blue2,
      blue3: colorPrimitives.base.blue5,
      gray: colorPrimitives.base.gray2,
      lightGray: colorPrimitives.base.gray1,
      progressText: colorPrimitives.base.black,
    },
    priority: {
      high: colorPrimitives.base.red2,
      medium: colorPrimitives.base.yellow1,
      low: colorPrimitives.base.gray3,
      content: colorPrimitives.base.black,
    },
  },
  components: {
    inputs: {
      borderEnabled: colorPrimitives.transparent.white["10"],
      iconEnabled: colorPrimitives.transparent.white["20"],
      borderHovered: colorPrimitives.accentBlue.dark["60"],
      borderFocused: colorPrimitives.accentBlue.dark["60"],
      iconFocused: colorPrimitives.transparent.white["70"],
      backgroundDisabled: colorPrimitives.transparent.white["10"],
      borderError: colorPrimitives.base.redAlertDark,
      borderErrorHovered: colorPrimitives.base.red2,
      helperTextError: colorPrimitives.base.redAlertDark,
      placeholder: colorPrimitives.transparent.white["30"],
      label: colorPrimitives.base.white,
      contentText: colorPrimitives.base.white,
      helperText: colorPrimitives.base.white,
    },
    checkbox: {
      empty: {
        enabled: colorPrimitives.transparent.white["40"],
        hovered: colorPrimitives.accentBlue.dark["60"],
        disabled: colorPrimitives.transparent.white["40"],
      },
      active: {
        enabled: colorPrimitives.base.white,
        hovered: colorPrimitives.accentBlue.dark["10"],
        disabled: colorPrimitives.transparent.white["10"],
        content: colorPrimitives.accentBlue.dark["80"],
      },
    },
    button: {
      icon: {
        backgroundRegular: colorPrimitives.transparent.black.lightBlack,
        border: colorPrimitives.transparent.white["6"],
        iconEnabledBlack: colorPrimitives.base.white,
        iconHoveredAccentBlue: colorPrimitives.accentBlue.dark["10"],
        iconEnabledDarkBlue: colorPrimitives.base.white,
        iconActiveBackground: colorPrimitives.accentBlue.dark["10"],
      },
      primary: {
        content: colorPrimitives.transparent.black.blue,
        backgroundEnabled: colorPrimitives.accentBlue.dark["10"],
        backgroundHovered: colorPrimitives.accentBlue.dark["60"],
        backgroundFocused: colorPrimitives.accentBlue.dark["100"],
        borderAndContentFocused: colorPrimitives.base.white,
        backgroundPressed: colorPrimitives.accentBlue.dark["60"],
        backgroundDisabled: colorPrimitives.transparent.white["30"],
        backgroundAlert: colorPrimitives.base.redAlert,
        backgroundAlertHovered: colorPrimitives.base.red2,
      },
      secondaryAndText: {
        contentAndBorderEnabled: colorPrimitives.accentBlue.dark["10"],
        contentAndBorderHovered: colorPrimitives.accentBlue.dark["60"],
        contentAndBorderFocused: colorPrimitives.accentBlue.dark["10"],
        backgroundFocused: colorPrimitives.accentBlue.dark["100"],
        contentAndBorderPressed: colorPrimitives.accentBlue.dark["80"],
        contentAndBorderDisabled: colorPrimitives.transparent.white["30"],
      },
    },
  },
});
